import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/CeoBio.scss";
import ceoPhoto from "../images/julieta.jpg"; // coloca aquí tu foto

const CeoBio = () => {
  return (
    <section className="ceoBio" id="ceo">
      <div className="ceoBio__wrap">
        <Fade duration={900} triggerOnce>
          <div className="ceoBio__photoArea">
            <div className="ceoBio__photoFrame" aria-hidden="true" />
            <img
              className="ceoBio__photo"
              src={ceoPhoto}
              alt="Julieta Zamora, CEO de Asesor-Arte en Seguros"
            />
          </div>
        </Fade>

        <Fade duration={900} delay={120} triggerOnce>
          <div className="ceoBio__content">
            <span className="ceoBio__eyebrow">CEO & Fundadora</span>
            <h2 className="ceoBio__title">Julieta Zamora</h2>

            <p className="ceoBio__lede">
              Mi propósito es ayudarte a construir el retiro que te dé
              tranquilidad, libertad y abundancia.
            </p>

            <p className="ceoBio__text">
              Soy <strong>Contadora Pública</strong>, con un <strong>MBA en Recursos Humanos</strong> y una
              <strong> certificación internacional como Coach por la ICF</strong> (International
              Coach Federation). Cuento con <strong>más de 15 años de experiencia</strong> en
              áreas clave como finanzas, seguridad social, compensaciones y
              planeación patrimonial, colaborando con empresas de alto nivel como
              <em> PwC, Danone, Hospital ABC, Four Seasons, Seguros Monterrey</em> y
              <em> Laboratorios Grossman</em>.
            </p>

            <p className="ceoBio__text">
              A lo largo de mi trayectoria, he visto de cerca cómo muchas personas,
              incluso con años de carrera profesional, llegan a su etapa madura
              sin una estrategia clara para su retiro. No porque no trabajaron o
              no quisieron, sino porque <strong>nadie les explicó a tiempo cómo planearlo
              bien</strong>.
            </p>

            <p className="ceoBio__text">
              Hoy me dedico a asesorar a personas como tú que buscan
              <strong> seguridad financiera</strong>, <strong>claridad</strong> y <strong>control</strong> sobre su futuro,
              diseñando <strong>planes de retiro estratégicos y flexibles</strong>, respaldados
              por aseguradoras líderes en México.
            </p>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default CeoBio;
